import { ContentInfo } from './ContentInfo';

export type { TypeContentInfoProps } from './types';
export default ContentInfo;
